export default __webpack_public_path__ + "static/media/icon-wc-logo.38180e40.svg";